/* eslint-disable react-refresh/only-export-components */
import { ColumnDef } from "@tanstack/react-table";
import {
  client,
  ModelSummaryDto,
  ModelsControllerListSummariesData,
  $ModelSummariesOrderEnum,
} from "@/client";
import { createTableContext } from "@/components/custom/data-table/data-table-context";
import { singleSelectColumn } from "@/components/custom/data-table/data-table-single-select-column";
import { isDefined } from "@/lib/utils";
import { useModelSelectionColumns } from "./model-selection-columns";

/**
 * Creates a table context for model selection with single-select behavior.
 * Uses singleSelectColumn for radio-button style row selection.
 */
export const createModelSelectionTableContext = () =>
  createTableContext<ModelSummaryDto, ModelsControllerListSummariesData>({
    queryArgument: () => ({ page: 1, limit: 10 }),
    getRowId: (row) => {
      if (isDefined(row?.id)) {
        return `${row.id}`;
      }
      console.warn("undefined row.id", row);
      return ``;
    },
    queryCreator: client.models.listSummaries.asQueryOptions,
    enableMultiRowSelection: false,
    columns: function useColumns() {
      const baseColumns = useModelSelectionColumns();
      return [
        singleSelectColumn as ColumnDef<ModelSummaryDto, unknown>,
        ...baseColumns,
      ];
    },
    defaultFilters: {
      name: undefined,
      type: undefined,
      role: undefined,
    },
    sortField: "sortBy",
    sortEnum: $ModelSummariesOrderEnum.enum,
    itemType: "Models",
    enableGallery: false,
  });

// Default context for backwards compatibility
export const ModelSelectionTableContext = createModelSelectionTableContext();
